import React, { useRef } from 'react';
import './Formulario.css'; // Importando o CSS do Formulário
import { useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import CodigoValidador from './CodigoForms';
import "./CodigoForms.css"; // Importando o CSS do Código Validador
import ConversaoBotao from '../Util/util.js';

export default function Formulario() {
    const [nome, setNome] = useState('');
    const [empresa, setEmpresa] = useState('');
    //const [cargo, setCargo] = useState('');
    const [cidade, setCidade] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [resposta, setResposta] = useState('');
    const codigoFormsRef = useRef();
    //const [novocodigo, setNovoCodigo] = useState();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append('nome', nome);
        formData.append('empresa', empresa);
        //formData.append('cargo', cargo);
        formData.append('cidade', cidade);
        formData.append('email', email);
        formData.append('telefone', telefone);
        formData.append('mensagem', mensagem);

        // if(!nome || !empresa || !cidade || !email || !telefone || !mensagem) {
        //     alert("Preencha todos os campos obrigatórios.");
        //     return;
        // } else if(!document.querySelector("#codigoAtivador").value) {
        //     alert("Preencha o código de ativação.");
        //     return;
        // }

        //alert($("#codigoAtivadorValido").val());
        //return false;

        if($("#codigoAtivadorValido").val() == "false") {
            alert("Código de ativação inválido.");

            $("#lblcodigoAtivador").addClass("marcaErro");
            setTimeout(() => {
                $("#lblcodigoAtivador").removeClass("marcaErro");
            }, 3000);
            $("#codigoAtivador").focus();
            return false;
        }


        // let data = {
        //     nome: nome,
        //     empresa: empresa,
        //     cargo: cargo,
        //     cidade: cidade,
        //     email: email,
        //     telefone: telefone,
        //     mensagem: mensagem,
        // }

        await axios.post('https://api.amanengenharia.com.br/send_email.php', formData,
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json; charset=UTF-8",
                "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
              }
            })
            .then((response) => {
                alert(response.data.mensagem);
                //document.querySelector(".success").style.cssText = "display: block; text-align: center;";
                setNome('');
                setEmpresa('');
                //setCargo('');
                setCidade('');
                setEmail('');
                setTelefone('');
                setMensagem('');
                setResposta(response.data.mensagem);
                //setNovoCodigo(true);
                if (codigoFormsRef.current) {
                    codigoFormsRef.current.gerarNovoCodigo();
                }
                
                ConversaoBotao("",2,"google",2);

                document.querySelector(".RespostaEmail").style.cssText = "display: block; background-color: #a1ffbe;";
                setTimeout(() => {
                    setResposta('');
                    document.querySelector(".RespostaEmail").style.cssText = "display: none;";
                }
                , 5000);
            })
            .catch((error) => {
                console.error("Error submitting form:", error);
                setResposta(error.response.data.mensagem);
                document.querySelector(".RespostaEmail").style.cssText = "display: block; background-color: #ffa1a1;";
                setTimeout(() => {
                    setResposta('');
                    document.querySelector(".RespostaEmail").style.cssText = "display: none;";
                }
                , 5000);
            });

        //const result = await res.json();
        //setResposta(result.mensagem);
    };

    // axios
    // .post("EnviaEmail.php", formData)
    // .then((response) => {
    //     //document.querySelector(".success").style.cssText = "display: block; text-align: center;";
    //     setFormData({
    //         nome: "",
    //         email: "",
    //         assunto: "",
    //         mensagem: "",
    //     });
    //     setErrors({});
    //     setIsLoading(false);
    // })
    // .catch((error) => {
    //     console.error("Error submitting form:", error);
    //     setIsLoading(false);
    // });

    return (
        <div className="formulario">
            <h1 className='margin-top-0'>Fale conosco</h1>
            Preencha o formulário abaixo e entraremos em contato o mais breve possível. 
            <br /> <br /> 
            <div className='RespostaEmail'>{resposta && <p>{resposta}</p>}</div>
            <form onSubmit={handleSubmit}>
                <ul>
                    <li>
                        <label htmlFor="nome">Nome:</label>
                        <br /><input type="text" id="nome" name="nome" value={nome} onChange={(e) => setNome(e.target.value)} placeholder='Digite seu nome' required />
                    </li>
                    <li>
                        <label htmlFor="empresa">Empresa:</label>
                        <br /><input type="text" id="empresa" name="empresa" value={empresa} onChange={(e) => setEmpresa(e.target.value)} placeholder='Digite sua empresa' required />
                    </li>
                    {/* <li>
                        <label htmlFor="cargo">Cargo:</label>
                        <br /><input type="text" id="cargo" name="cargo" value={cargo} onChange={(e) => setCargo(e.target.value)} placeholder='Digite seu cargo' />
                    </li> */}
                    <li>
                        <label htmlFor="cidade">Cidade:</label>
                        <br /><input type="text" id="cidade" name="cidade" value={cidade} onChange={(e) => setCidade(e.target.value)} placeholder='Digite sua cidade' required />
                    </li>
                    <li>
                        <label htmlFor="email">Email:</label>
                        <br /><input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Digite seu email' required />
                    </li>
                    <li>
                        <label htmlFor="telefone">Telefone:</label>
                        <br /><input type="tel" id="telefone" name="telefone" value={telefone} onChange={(e) => setTelefone(e.target.value)} placeholder='Digite seu telefone' required />
                    </li>
                    <li>
                        <label htmlFor="mensagem">Mensagem:</label>
                        <br /><textarea type="text" id="mensagem" name="mensagem" value={mensagem} onChange={(e) => setMensagem(e.target.value)} placeholder='Digite sua mensagem' required />
                    </li>
                    <li>
                        <CodigoValidador ref={codigoFormsRef} />
                    </li>
                </ul>
                <button type="submit">Enviar</button>
            </form>
        </div>
    )
}